import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Duplicar", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Salvar e Novo", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_14 = { class: "ant-col ant-col-xs-20 ant-col-xl-20" }
const _hoisted_15 = {
  style: {"display":"none"},
  class: "ant-row"
}
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_operacao = _resolveComponent("selecionar-tipo-operacao")!
  const _component_selecionar_tipo_movimento_comercial = _resolveComponent("selecionar-tipo-movimento-comercial")!
  const _component_selecionar_tabela_preco = _resolveComponent("selecionar-tabela-preco")!
  const _component_card = _resolveComponent("card")!
  const _component_forma_pagamento_tipos_pagamento = _resolveComponent("forma-pagamento-tipos-pagamento")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    style: {"width":"1000px"},
    centered: "",
    "wrap-class-name": "scroll-modal ss-modal-cadastros"
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Cadastro de Formas de Pagamento "),
      _createVNode(_component_a_switch, {
        checked: _ctx.state.formaPagamento.ativo,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.formaPagamento.ativo) = $event)),
        style: {"float":"right"},
        "checked-children": "Ativa",
        "un-checked-children": "Inativa"
      }, null, 8, ["checked"])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir) || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.duplicarRegistro && _ctx.duplicarRegistro(...args)))
                }, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(true)))
            }, _hoisted_5),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.salvar(false)))
            }, _hoisted_7)
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_a_form_item, {
                            label: "Descrição",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "250",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.formaPagamento.descricao) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.formaPagamento.descricao]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipos de Operação",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_tipo_operacao, {
                                valor: _ctx.state.formaPagamento.tipoOperacao,
                                "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.formaPagamento.tipoOperacao) = $event)),
                                onChange: _ctx.alterarTipoOperacao
                              }, null, 8, ["valor", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipos de Movimentação",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_tipo_movimento_comercial, {
                                varios: true,
                                apenasEntradas: _ctx.state.formaPagamento.tipoOperacao === _ctx.ETipoOperacao.Entrada,
                                apenasSaidas: _ctx.state.formaPagamento.tipoOperacao === _ctx.ETipoOperacao.Saida,
                                valoresSelecionados: _ctx.state.tiposMovimento,
                                "onUpdate:valoresSelecionados": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.tiposMovimento) = $event))
                              }, null, 8, ["apenasEntradas", "apenasSaidas", "valoresSelecionados"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_a_form_item, {
                            label: "Tabelas de Preços",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_tabela_preco, {
                                varios: true,
                                empresas: [_ctx.state.formaPagamento.codigoEmpresa],
                                codigosSelecionados: _ctx.state.tabelasPrecos,
                                "onUpdate:codigosSelecionados": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.tabelasPrecos) = $event))
                              }, null, 8, ["empresas", "codigosSelecionados"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_forma_pagamento_tipos_pagamento, {
                        codigosTiposUtilizados: _ctx.state.codigosTiposUtilizados,
                        empresa: _ctx.state.formaPagamento.codigoEmpresa,
                        tiposDocumentosFinanceiro: _ctx.state.formaPagamento.tiposDocumentosFinanceiro,
                        "onUpdate:tiposDocumentosFinanceiro": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.formaPagamento.tiposDocumentosFinanceiro) = $event)),
                        tipoOperacao: _ctx.state.formaPagamento.tipoOperacao
                      }, null, 8, ["codigosTiposUtilizados", "empresa", "tiposDocumentosFinanceiro", "tipoOperacao"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible"]))
}